import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({ baseURL: window.location.origin })

export function signInWithMicrosoft(): Promise<unknown> {
  return authClient.signIn.social({ provider: 'microsoft', callbackURL: '/' })
}
